var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTradestationLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 56 56"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 8,
    fill: "#1288C9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.05 35.37L31.79 14H19.33a5.98 5.98 0 00-5.6 3.89l-1.13 3.02h8.22s-1.13 1.73-1.13 5.35c0 4.65 2.9 8.01 4.36 9.11zm20.63-21.21H34.2l-2.58 6.75h6.94c2.7 0 6.12-3.45 6.12-6.75zM22.76 44.8l7.9-21.06C33.88 26.41 35 29.56 35 33.5c0 3.92-1.77 5.97-4.35 8.64-2.07 2.14-6.13 2.67-7.9 2.67z",
    fill: "#fff"
  })));
}

export default SvgTradestationLogo;